import { generateRandomNonce } from '#crypto';
import { generateClientProof, ScramError, verifyClientProof, } from './scram-primitives';
export const generateClientFirstMessage = (email) => {
    return {
        email,
        clientNonce: generateRandomNonce(),
    };
};
export const generateServerFirstMessage = (clientNonce, salt, iterations) => {
    return {
        iterations,
        salt,
        fullNonce: clientNonce + generateRandomNonce(),
    };
};
export const generateClientFinalMessage = async (clientFirstMessage, serverFirstMessage, password) => {
    if (!serverFirstMessage.fullNonce.startsWith(clientFirstMessage.clientNonce)) {
        throw new ScramError('Authentication failed');
    }
    return {
        proof: await generateClientProof(password, clientFirstMessage.email, serverFirstMessage),
        fullNonce: serverFirstMessage.fullNonce,
    };
};
export const verifyClientFinalMessage = (scramRecord, clientFinalMessage, email, serverFullNonce) => verifyClientProof(scramRecord, clientFinalMessage, email, serverFullNonce);
